import { CookieService } from "@Front/Services/CookieService/CookieService";

export async function waitForCookieAvailability(
	cookieName: string,
	maxWaitMs: number = 500,
	pollIntervalMs: number = 10,
): Promise<void> {
	const startTime = Date.now();
	const cookieService = CookieService.getInstance();

	while (Date.now() - startTime < maxWaitMs) {
		const cookie = cookieService.getCookie(cookieName);
		if (cookie) {
			return;
		}
		await new Promise((resolve) => setTimeout(resolve, pollIntervalMs));
	}

	throw new Error(`Cookie ${cookieName} not available after ${maxWaitMs}ms`);
}
